import { useEffect, useState } from "react"
import { useCartContext } from "@providers/cart"
import { useCart } from "@hooks/useCart"
import { useStorage } from "@hooks/useCore"
import { useConfigContext } from "@providers/config"

type DeliveryMethod = "HomeDelivery" | "ClickAndCollect"

const useDeliveryMethod = () => {
  const { cart } = useCartContext()
  const {
    settings: { keys },
  } = useConfigContext()
  const { updateCartAttributes } = useCart()
  const { removeStorage } = useStorage()
  const [loading, setLoading] = useState<boolean>(false)
  const [deliveryMethod, setDeliveryMethod] = useState<DeliveryMethod | null>(null)
  const [openClickAndCollect, setOpenClickAndCollect] = useState<boolean>(false)

  const customAttributes = cart?.attributes
  const useClickAndCollect = customAttributes?.find(({ key }: any) => key === "_click_and_collect")?.value
  const pickupStoreName = customAttributes?.find(({ key }: any) => key === "pickup_store_name")?.value

  useEffect(() => {
    if (useClickAndCollect === "true") setDeliveryMethod("ClickAndCollect")
    else setDeliveryMethod("HomeDelivery")
  }, [useClickAndCollect])

  const setHomeDelivery = async () => {
    setLoading(true)

    const customAttributes: CustomAttribute[] = [
      { key: "_click_and_collect", value: "false" },
    ]

    removeStorage(keys?.store)

    await updateCartAttributes({ customAttributes })
    setLoading(false)
    setDeliveryMethod("HomeDelivery")
  }

  const setClickAndCollect = () => setOpenClickAndCollect(true)
  const closeClickAndCollect = () => setOpenClickAndCollect(false)

  return { deliveryMethod, pickupStoreName, openClickAndCollect, loading, setHomeDelivery, setClickAndCollect, closeClickAndCollect }
}

export default useDeliveryMethod
